module.exports = __webpack_public_path__ + "static/media/cctv_use.1436d6e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tab-images/cctv_use.jpg
// module id = 215
// module chunks = 0